import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ImpattoIro,
  Opportunita,
  Rischio,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { DialogCreaIroComponent } from '../dialog-crea-iro/dialog-crea-iro.component';

@Component({
  selector: 'app-dialog-visual-validazioni-iro',
  standalone: false,
  templateUrl: './dialog-visual-validazioni-iro.component.html',
  styleUrl: './dialog-visual-validazioni-iro.component.scss',
})
export class DialogVisualValidazioniIroComponent {
  private _tipoIro: string = '';

  get tipoIro() {
    return this._tipoIro;
  }

  private _titolo: string = '';

  get titolo() {
    return this._titolo;
  }

  constructor(
    public readonly dialogRef: MatDialogRef<DialogCreaIroComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipoIro: 'impatto' | 'rischio' | 'opportunita';
      elemento: ImpattoIro | Rischio | Opportunita;
    },
  ) {
    if (data.tipoIro === 'impatto') {
      this._tipoIro = 'Impatto';
      this._titolo = (data.elemento as ImpattoIro).titolo;
    } else if (data.tipoIro === 'rischio') {
      this._tipoIro = 'Rischio';
      this._titolo = (data.elemento as Rischio).descrizione;
    } else if (data.tipoIro === 'opportunita') {
      this._tipoIro = 'Opportunità';
      this._titolo = (data.elemento as Opportunita).descrizione;
    }
  }
}
